const menuDrawerIcon = document.querySelector('.header__icon--menu');
menuDrawerIcon.addEventListener('click', () => {
  document.body.classList.toggle('menu-drawer-opened');

  if (menuDrawerIcon.dataset.drawerScheme == menuDrawerIcon.dataset.navScheme) return;
  
  document.querySelector('.header-wrapper').classList.toggle(menuDrawerIcon.dataset.drawerScheme);
  document.querySelector('.header-wrapper').classList.toggle(menuDrawerIcon.dataset.navScheme);
});

const heroVideoToggle = document.querySelectorAll('.hero-video-toggle');
heroVideoToggle.forEach((videoToggle) => {
  videoToggle.addEventListener('click', () => {
    const video = videoToggle.closest('.hero').querySelector('video');
    const text = videoToggle.querySelector('.text');
    
    if (!video) return;

    if (video.paused) {
      video.play();
      videoToggle.classList.remove('is-paused');
      
      if (text) text.textContent = videoToggle.dataset.pauseText;
    } else {
      video.pause();
      videoToggle.classList.add('is-paused');

      if (text) text.textContent = videoToggle.dataset.playText;
    }
  });
});

const iconTextSlider = document.querySelectorAll('.icon-text-columns__slider');
iconTextSlider.length && iconTextSlider.forEach((slider) => {
  let sliderInit;
  const sliderOptions = { slidesPerView: 'auto', pagination: { el: '.swiper-pagination', clickable: true } };
  
  if (slider.dataset.slider == 'desktop') {
    window.innerWidth > 749 && (sliderInit = new Swiper(slider, sliderOptions)),
    window.addEventListener('resize', function () {
      window.innerWidth < 750 && sliderInit?.enabled ? sliderInit.destroy() : (window.innerWidth > 749 && (!sliderInit || sliderInit?.destroyed)) && (sliderInit = new Swiper(slider, sliderOptions));
    });
  } else if (slider.dataset.slider == 'mobile') {
    window.innerWidth < 750 && (slider = new Swiper(slider, sliderOptions)),
    window.addEventListener('resize', function () {
      window.innerWidth > 749 && sliderInit?.enabled ? sliderInit.destroy() : (window.innerWidth < 750 && (!sliderInit || sliderInit?.destroyed)) && (sliderInit = new Swiper(slider, sliderOptions));
    });
  } else if (slider.dataset.slider == 'both') {
    sliderInit = new Swiper(slider, sliderOptions)
  }
});

function setWizardContentHeight() {
  document.querySelectorAll('.wizard-steps__item').forEach((wizardItem) => {
    const wizardContentHeight = (wizardItem.classList.contains('is-active')) ? wizardItem.querySelector('.wizard-steps__item-container').offsetHeight + 'px' : '0px';
    wizardItem.querySelector('.wizard-steps__item-inner').style.height = wizardContentHeight;
  });
}

setWizardContentHeight();
window.onresize = setWizardContentHeight;

const wizardsToggle = document.querySelectorAll('.wizard-steps__item-toggle');
wizardsToggle.forEach((wizardToggle) => {
  wizardToggle.addEventListener('click', () => {
    const parentEle = wizardToggle.closest('.wizard-steps__item');
    const activeEle = wizardToggle.closest('.wizard-steps__list').querySelector('.wizard-steps__item.is-active');
    const contentHeight = parentEle.querySelector('.wizard-steps__item-container').offsetHeight;
    
    if (activeEle) {
      activeEle.classList.remove('is-active');
      activeEle.querySelector('.wizard-steps__item-inner').style.height = '0px';
    }
    
    wizardToggle.closest('.wizard-steps__item').classList.add('is-active');
    parentEle.querySelector('.wizard-steps__item-inner').style.height = contentHeight + 'px';
  });
});

const faqAccordions = document.querySelectorAll('.accordion-item-heading');
faqAccordions.forEach((faqAccordion) => {
  faqAccordion.addEventListener('click', () => {
    if (faqAccordion.parentElement.classList.contains('active')) {
      faqAccordion.parentElement.classList.remove('active');
    } else {
      const activeFaqAccordion = faqAccordion.closest('.faq-content-accordion').querySelector('.accordion-item.active');
      if (activeFaqAccordion) activeFaqAccordion.classList.remove('active');
      
      faqAccordion.parentElement.classList.add('active');
    }
  });
});

const productThumbSlider = new Swiper('.thumbnail-slider', {
  loop: true,
  slidesPerView: 'auto',
  freeMode: true,
  watchSlidesProgress: true,
});

const productMainSlider = new Swiper('.product__media-main', {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  thumbs: {
    swiper: productThumbSlider,
  },
});

const upsellSwiper = new Swiper('.upsell-bundles-main', {
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});

function validateForm(input) {
  const submit = input.closest('form').querySelector('[data-validation-submit]');
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (input.value.trim() === '') {
    input.classList.add('error');

    if (input.nextElementSibling) {
      switch (input.dataset.validationInput) {
        case 'email':
          input.nextElementSibling.textContent = 'Please enter your email';
          break;
        case 'password':
          input.nextElementSibling.textContent = 'Please enter your password';
          break;
        case 'first-name':
          input.nextElementSibling.textContent = 'Please enter your first name';
          break;
        default:
          input.nextElementSibling.textContent = "This field can't be blank";
      }
    }
  } else if (input.dataset.validationInput == 'email' && !emailRegex.test(input.value)) {
    input.classList.add('error');
    input.nextElementSibling.textContent = 'Email is invalid';
  } else {
    input.classList.remove('error');
    if (input.nextElementSibling) input.nextElementSibling.textContent = '';
  }

  const inputHasError = formHasErrors(input.closest('form'));
  if (submit) submit.disabled = (inputHasError) ? true : false;
}

function formHasErrors(form) {
  const formInputs = form.querySelectorAll('[data-validation-input]');
  return Array.from(formInputs).some((formInput) => formInput.classList.contains('error'));
}

const validationForms = document.querySelectorAll('[data-validation-form]');
validationForms.forEach((form) => {
  const submit = form.querySelector('[data-validation-submit]');
  submit?.addEventListener('click', (event) => {
    event.preventDefault();

    form.querySelectorAll('[data-validation-input]').forEach((input) => { validateForm(input) });

    const inputHasError = formHasErrors(form);
    if (inputHasError) return;

    form.submit();
  });
});

const validationFormInputs = document.querySelectorAll('[data-validation-input]');
validationFormInputs.forEach((input) => {
  input.addEventListener('input', () => { validateForm(input) });
});

const dropdownTabsLabel = document.querySelector('.dropdown-tabs__label');
dropdownTabsLabel?.addEventListener('click', () => { dropdownTabsLabel.classList.toggle('active') });

class FeaturedTabsContent extends HTMLElement {
  constructor() {
    super();
    
    this.init();
  }

  init() {
    const sliderEle = this.querySelector('.featured-tabs-content__slider');
    
    const slider = new Swiper(sliderEle, {
      slidesPerView: 'auto',
      roundLengths: true,
      allowTouchMove: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    const tabs = this.querySelectorAll('.featured-tabs-content__tab');
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        tabs.forEach((tabs2) => { tabs2.classList.remove('active') });
        tab.classList.add('active');
    
        slider.slideTo(index);
        this.scrollToTab(tab);
      });
    });

    slider.on('slideChange', () => {
      tabs.forEach((tab, index) => { 
        if (index == slider.activeIndex) {
          tab.classList.add('active');
          this.scrollToTab(tab);
        } else {
          tab.classList.remove('active');
        }
      });
    });
  }

  scrollToTab(tab) {
    const tabs = this.querySelector('.featured-tabs-content__tabs'), offsetLeft = (tabs.scrollLeft + tab.getBoundingClientRect().left) - 62;
    tabs.scrollTo({ top: 0, left: offsetLeft, behavior: 'smooth' });
  }
}
customElements.define('featured-tabs-content', FeaturedTabsContent);

class ProductList extends HTMLElement {
  constructor() {
    super();
    
    this.init();
  }

  init() {
    const tabs = this.querySelectorAll('.product-list__tab'), products = this.querySelectorAll('.product-list__item'), buttons = this.querySelectorAll('.product-list__buttons');
    
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        tabs.forEach((tabs2) => { tabs2.classList.remove('active') });
        tab.classList.add('active');

        products.forEach((product) => { (product.dataset.title == tab.dataset.target || tab.dataset.target == 'all') ? product.classList.remove('hidden') : product.classList.add('hidden') });
        buttons.forEach((button) => { (button.dataset.title == tab.dataset.target && tab.dataset.target != 'all') ? button.classList.remove('hidden') : button.classList.add('hidden') });
        
        this.scrollToTab(tab);
      });
    });
  }

  scrollToTab(tab) {
    const tabs = this.querySelector('.product-list__tabs'), offsetLeft = (tabs.scrollLeft + tab.getBoundingClientRect().left) - 62;
    tabs.scrollTo({ top: 0, left: offsetLeft, behavior: 'smooth' });
  }
}
customElements.define('product-list', ProductList);

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    
    this.init();
  }

  init() {
    const sliderEle = this.querySelector('.video-slider');
    
    const slider = new Swiper(sliderEle, {
      centeredSlides: true,
      centerInsufficientSlides: true,
      centeredSlidesBounds: true,
      slidesPerView: 'auto',
      roundLengths: true,
    });
  }
}
customElements.define('video-gallery', VideoGallery);

class BlogTags extends HTMLElement {
  constructor() {
    super();
    
  }

  connectedCallback() {
    const tags = this.querySelectorAll('.blog-tags__item');
    tags.forEach((tag) => {
      tag.addEventListener('click', (event) => {
        event.preventDefault();
        if (tag.classList.contains('active')) return;

        this.renderInfo(tag.href);
        this.scrollToTag(tag);

        tags.forEach((otherTag) => { otherTag.classList.remove('active') });
        tag.classList.add('active');
      });

      if (tag.classList.contains('active')) this.scrollToTag(tag);
    });
  }

  renderInfo(url) {
    fetch(`${url}?section_id=${this.dataset.section}`)
    .then(response => response.text())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      const blogsContent = document.getElementById('BlogArticlesContent');
      if (blogsContent) blogsContent.innerHTML = html.querySelector('#BlogArticlesContent').innerHTML;
    }).catch((error) => {
      console.log('error', error);
    })
  }

  scrollToTag(tag) {
    const offsetLeft = (this.scrollLeft + tag.getBoundingClientRect().left) - 62;
    this.scrollTo({ top: 0, left: offsetLeft, behavior: 'smooth' });
  }
}

customElements.define('blog-tags', BlogTags);